import {useNavigate, useLocation} from "react-router-dom";
import packageJson from '../../package.json';
import React from "react";

//Стили
import "./style/greeting.css";
import "./style/palette.css";
import "./style/common.css";

//Универсальная страница ошибок
export default function ErrorPage() {
    const navigate = useNavigate();
    const location = useLocation();

    const errorCode = location.state?.code || "500";
    const errorTitle = location.state?.title || "Внутренняя ошибка сервера";
    const errorMessage = location.state?.message || "На сервере произошла непредвиденная ошибка. Пожалуйста, попробуйте обновить страницу позже.";

    //На главную
    const handleGoHomeClick = () => {
        navigate("/");
    };

    //Обновить страницу
    const handleReloadClick = () => {
        window.location.reload();
    };

    return (
        <div className={"d-flex flex-column align-items-center"}>
            <div id={"greeting"}>
                <div id={"greeting-block"} className={"mx-2"}>
                    <div className={"greeting-img-block"}>
                        <img src={"../icons/logo-idgos.png"} alt={"!#"} className={"logo-idgos"}/>
                    </div>
                    <div className={"greeting-text-block"}>
                        <h1 className={"greeting-title text-center"}>
                            {errorCode}
                        </h1>
                        <p className={`greeting-subtitle text-center fw-bold color_red`}>
                            {errorTitle}
                        </p>
                        <p className={"greeting-subtitle text-center"}>
                            {errorMessage}
                        </p>
                    </div>

                    <div className={"d-flex flex-column align-items-center mt-3"}>
                        <button onClick={handleReloadClick}
                                className={"border-0 greeting-continue greeting-continue-false mb-2"}>
                            Обновить страницу
                        </button>
                        <button onClick={handleGoHomeClick}
                                className={"border-0 greeting-continue greeting-continue-false"}>
                            На главную
                        </button>
                    </div>
                </div>
            </div>
            <div className={"app-version text-end width90"}>версия {packageJson.version}</div>
        </div>
    );
};
